import { gql } from "@stadium/services/apollo-client";

export const createSession = gql`
  mutation CreateSession($input: SessionCreateInput!) @api(name: "users") {
    createSession(input: $input) {
      success
      uid
      channel
    }
  }
`;
